import axios from 'axios'
import {toData} from "./util";

export function all(query, subsidiaryId): Promise {
  return axios.get('/api/subsidiaries').then(toData)
}

export function get(id): Promise {
  return axios.get(`/api/subsidiaries/${id}`).then(toData)
}

export function update(subsidiary): Promise {
  return axios.put(`/api/subsidiaries/${subsidiary.id}`, subsidiary).then(toData)
}

export function importPDFTemplate(id, formData,config): Promise {
  return axios.post(`/api/subsidiaries/${id}/activationCodePDFTemplate`, formData,config).then(toData)
}

export function downloadPDFTemplate(id): Promise {
  return axios.get(`/api/subsidiaries/${id}/activationCodePDFTemplate`).then(toData)
}
